import { render, staticRenderFns } from "./StreamAnomalyDetection.vue?vue&type=template&id=4bcb55a6&"
import script from "./StreamAnomalyDetection.vue?vue&type=script&lang=ts&"
export * from "./StreamAnomalyDetection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports